<app-toast-wrapper>
  <div class="warning-toast">
    <div class="warning-toast__icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path d="M0 0h24v24H0z" fill="none"></path>
        <path
          class="warning-toast__icon-content"
          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
        ></path>
      </svg>
    </div>
    <div class="warning-toast__text">
      {{ data.message }}
    </div>
  </div>
</app-toast-wrapper>
